/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: api\index.ts
 🗓️ Created: 2026-05-02
 🧩 Description:
    Implementation of the Provisioning Vendors module.
────────────────────────────────────────────────────────────────*/

import { api } from '../../../lib/api';

export interface Vendor {
    id: number;
    uuid?: string;
    name: string;
    websiteUrl?: string;
    supportUrl?: string;
    macPrefixes?: string[];
    provisioningProtocols?: string[];
    supportsRedirection?: boolean;
    notes?: string;
    logo?: string;
    _count?: { models: number };
}

// API Functions
export const getVendors = () => api.get<Vendor[]>('/api/apps/provisioning/vendors').then(res => res.data);
export const getVendor = (id: number | string) => api.get<Vendor>(`/api/apps/provisioning/vendors/${id}`).then(res => res.data);
export const createVendor = (data: Partial<Vendor>) => api.post<Vendor>('/api/apps/provisioning/vendors', data).then(res => res.data);
export const updateVendor = (id: number | string, data: Partial<Vendor>) => api.put<Vendor>(`/api/apps/provisioning/vendors/${id}`, data).then(res => res.data);
export const deleteVendor = (id: number | string) => api.delete(`/api/apps/provisioning/vendors/${id}`);
